/**
 * @name statemachine
 * @class
 * @description provides a finite state machine, inspired by <a href="https://github.com/jakesgordon/javascript-state-machine">Jake Gordon's State Machine</a>. <strong>Note</strong> there are some differences.
 * @example var sm = new statemachine({
 initial: 'green',
 states: {
   'warn':  { from: 'green',  to: 'yellow' },
   'panic': { from: 'yellow', to: 'red' },
   'calm':  { from: 'red',    to: 'yellow' },
   'clear': { from: 'yellow', to: 'green' }
 }
 });

 sm.current(); // returns 'green'

 sm.can('warn'); // returns true
 sm.can('panic'); // returns false

 sm.cannot('panic'); // returns true
 sm.cannot('warn'); // returns false

 sm.warn(); // changes state to 'yellow'.
 sm.panic(); // changes state to 'red'.

 sm.available() // returns list [panic, clear]

**/
export default class statemachine {
  constructor(opts) {
    this.current_state = opts.initial;
    this.states = opts.states || {};

    for (const state in this.states) {
      statemachine.prototype[state] = function () {
        this.transition(state)
      }
    }

  }

  // This should be private, but lifes to short to wait for TC39...
  transition(state) {
    if(this.cannot(state)) { throw 'Can not call ' + state; }
    this.current_state = this.states[state].to;
  }

  // Returns current state
  current()
  {
    return this.current_state;
  }

  // is the current state X?
  is(state) {
    return this.current_state == state;
  }

  // Can I can change the current state with state name
  can(state) {
    return this.states[state].from == this.current_state;
  }

  // Can I not change the current state with state name
  cannot(state) {
    return !this.can(state);
  }

  // returns a list of available state names based on current state
  available() {
    let available_states = [];
    available_states.push(this.current());

    for (const state in this.states) {
      if(this.states[state].from == this.current_state) {
        available_states.push(state);
      }
    }

    return available_states;
  }
}
